module.exports = __webpack_public_path__ + "img/anexo.648c09ad.svg";